<template>
    <b-modal id="confirm-leave" centered :title="'Уйти со страницы?'">
        <template #default>
            <div class="d-flex flex-column">
                <span>Внесенные изменения не сохранятся.</span>
                <span class="text-secondary mt-3">
                    <b-icon icon="info-circle" variant="secondary"/>
                    Чтобы сохранить изменения, закройте это окно и нажмите кнопку "Сохранить" внизу формы.
                </span>
            </div>
        </template>
        <template #modal-footer>
            <b-button variant="secondary" @click="stay">Остаться и продолжить редактирование</b-button>
            <b-button variant="primary" @click="leave">Уйти</b-button>
        </template>
    </b-modal>
</template>

<script>
    export default {
        name: "ConfirmLeaveModal",
        props: {
            leaveBrowserConfirm: false,  // для показа уведомления от браузера при использовании браузерной навигации
            silentLeave: false,
        },
        data() {
            return {
                resolveLeave: null,
                rejectLeave: null,
            }
        },
        methods: {
            showConfirmLeave() {
                this.$bvModal.show('confirm-leave');
                return new Promise((resolve, reject) => {
                    this.resolveLeave = resolve;
                    this.rejectLeave = reject;
                })
            },
            stay() {
                this.$bvModal.hide('confirm-leave');
                this.rejectLeave();
            },
            leave() {
                this.$bvModal.hide('confirm-leave');
                this.resolveLeave(this.silentLeave);
            },
        },
        mounted() {
            window.onbeforeunload = () => {
                if (this.leaveBrowserConfirm) {
                    return true;
                } else {
                    return null
                }
            }
        }
    }
</script>

<style scoped>

</style>